import { message } from "antd";
import axios from "axios";
import { ApiResponse } from "../context/VolunteersHighlightContext/constants";
import { getErrorMessage } from "./errorUtils";

// The message of an unsuccessful CMS response, whether the backend sent it as text or as an error object.
export const getResponseErrorMessage = (response: ApiResponse<unknown>) => {
	const error = response.error;
	if (typeof error === "string") {
		return error;
	}
	return error?.message || "Beklenmedik bir hata oluştu.";
};

export const isNotFoundError = (error: unknown) => axios.isAxiosError(error) && error.response?.status === 404;

// Shows a failed request as an error toast; a 404 gets the screen's own "not found" text.
export const showRequestError = (error: unknown, notFoundMessage: string) => {
	console.error(error);
	message.error(isNotFoundError(error) ? notFoundMessage : getErrorMessage(error));
};
